import './index.scss'
$(".backtop").click(function () {
    $('body,html').animate({
        scrollTop: 0
    }, 400);
})